import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_TEAM_PLANS = "team-plans";

const getData = async (props: { token: string }): Promise<any[]> => {
  const url = `${END_POINT.BASE_URL}/v1/team-package-plan`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);

  return res.data;
};

export const useGetPackagePlans = () => {
  const { token } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_TEAM_PLANS],
    () => getData({ token }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );

  return queryData;
};
